export const getSentryRelease = (version: string, gitSha?: string): string => {
  const shortSha = gitSha?.trim().slice(0, 7);

  return shortSha ? `v${version}+${shortSha}` : `v${version}`;
};
